import { render } from "./invoiceModel.vue?vue&type=template&id=039e1a58"
import script from "./invoiceModel.vue?vue&type=script&lang=js"
export * from "./invoiceModel.vue?vue&type=script&lang=js"

import "./invoiceModel.vue?vue&type=style&index=0&id=039e1a58&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__